import { StringUtils } from './stringUtils';
import { globalConfig } from '../../../config/globalConfig';

export function encode() {
    return StringUtils.utf8_to_base64(`${globalConfig.appScope}:${globalConfig.appId}`);
}
